/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  Portal,
  MenuList,
} from "@chakra-ui/react"; // Npm: Chakra UI components.


/*
 * OBJECTS
 */
const Index = ({
  vendorId,
  vendorInvoiceId,
  invoiceNumber,
  onVendorInvoiceUpdate,
  onVendorInvoiceDelete,
  PassOnUpdate,
}) => (
  <Menu placement="left">
    <MenuButton
      as={Button}
      margin="auto"
      borderRadius="8px"
      color="gray.500"
      bg="transparent"
    >
      <HiPencil size={18} />
    </MenuButton>
    <Portal>
      <MenuList className="dropDownMenu" maxHeight="400px" overflow="auto">
        <MenuItem
          gap="12px"
          display="flex"
          pl="20px"
          pr="20px"
          color="gray.500"
          onClick={() => {
            // Push vendorAccount id to url.
            PassOnUpdate({ vendorId, vendorInvoiceId, invoiceNumber });

            // Execute handler.
            onVendorInvoiceUpdate();
          }}
          minH="40px"
        >
          <HiPencil size={18} />
          <span>Update Vendor Invoice</span>
        </MenuItem>
        <MenuItem
          gap="12px"
          display="flex"
          pl="20px"
          pr="20px"
          color="gray.500"
          onClick={() => {
            // Push vendorAccount id to url.
            PassOnUpdate({ vendorId, vendorInvoiceId, invoiceNumber });

            // Execute handler.
            onVendorInvoiceDelete();
          }}
          minH="40px"
        >
          <HiTrash />
          <span>Delete Vendor Invoice</span>
        </MenuItem>
      </MenuList>
    </Portal>
  </Menu>
);


/*
 * PROPTYPES
 */
Index.propTypes = {
  vendorId: PropTypes.string,
  onVendorInvoiceUpdate: PropTypes.func,
  onVendorInvoiceDelete: PropTypes.func,
  invoiceNumber: PropTypes.string,
  PassOnUpdate: PropTypes.func,
  vendorInvoiceId: PropTypes.string,
};


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
